/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* React */
import React, { useContext, useState } from 'react';

/* Translation */
import { useTranslation } from 'react-i18next';

/* Components */
import ClassroomItem from './ClassroomItem';

/* Styled Components */
import {
  List,
  ClassroomHeader,
  ClassroomName,
  StudentCount,
  StyledClassCodeWrapper,
  InfoBtn,
  ListEmpty,
  HelperText,
} from './styles/ClassroomList';

/* Services, Hooks, Constants */
import { AppContext } from 'App';
import { APP_SECTIONS_PATHS } from 'constants/routes';
import { useRouter } from 'routes/index';
import { TooltipSortArrow } from '../SortArrow';
import useCurrentUser from 'hooks/useCurrentUser';
import { ActionPermission } from 'lib/specialPermissions';

interface ClassroomListProps {
  classrooms?: any;
  coreClassrooms?: any;
  handleOnDeleteClassroom?: any;
}

const ClassroomList: React.FC<ClassroomListProps> = ({
  classrooms,
  coreClassrooms,
  handleOnDeleteClassroom,
}) => {
  const { t } = useTranslation();
  const { history } = useRouter();
  const [alphaSort, setAlphaSort] = useState(false);
  const [info, setInfo] = useState(false);
  const { can } = useCurrentUser();
  const { isFreemiumUser, isDemoUser } = useContext(AppContext);

  /* sort classrooms alphabetically */
  const sortedClassrooms = classrooms.sort((a: any, b: any) =>
    a.name.localeCompare(b.name));

  /* ADD STUDENT functions */
  const handleAddStudent = (clientClass: any, coreClass: any) => {
    if (isFreemiumUser || isDemoUser) {
      return history.push(APP_SECTIONS_PATHS.PREMIUM_PROCESS);
    }
    const currentPath = history.location.pathname.replace('/', '');
    return history.push(
      `${APP_SECTIONS_PATHS.ADD_STUDENTS}?prevView=${currentPath}&groupId=${clientClass?.external_id}&publicId=${coreClass[0]?.public_id}&groupName=${clientClass?.name}`,
    );
  };

  /* SORT classroom list */
  const renderClassrooms = (list: any) => {
    return list.map((classroom: any, index: number) => {
      return (
        <ClassroomItem
          classroom={classroom}
          key={index}
          coreClassrooms={coreClassrooms}
          handleAddStudent={handleAddStudent}
          canAddStudents={can(ActionPermission.ADD_STUDENTS)}
          canDeleteItem={can(ActionPermission.DELETE_CLASSROOMS)}
          handleOnDeleteClassroom={handleOnDeleteClassroom}
        />
      );
    });
  };

  return (
    <List>
      <ClassroomHeader>
        <ClassroomName>
          {t('settings:CLASSROOM_NAME')}
          <TooltipSortArrow sorted={alphaSort} onSort={setAlphaSort} />
        </ClassroomName>
        <StudentCount>{t('calendar_events:STUDENTS')}</StudentCount>
        <StyledClassCodeWrapper>
          {t('common:CLASSCODE.CLASS_ID')}
          <InfoBtn
            onMouseOver={() => setInfo(true)}
            onMouseOut={() => setInfo(false)}
          />
          {info && <HelperText>{t('CLASSCODE.CLASS_INFO')}</HelperText>}
        </StyledClassCodeWrapper>
      </ClassroomHeader>
      {classrooms && classrooms.length > 0 ? (
        renderClassrooms(
          alphaSort ? sortedClassrooms.reverse() : sortedClassrooms,
        )
      ) : (
        <ListEmpty>{t('settings:CENTER_SECTION.CLASSROOM_EMPTY')}</ListEmpty>
      )}
    </List>
  );
};

export default ClassroomList;
